import { ReactElement } from 'react';
import classnames from 'classnames';

interface StackedSectionProps {
  title?: string;
  text: string;
  btnText: string;
  img: string;
  link: string;
  icon?: string;
  light?: boolean;
  alt?: string;
}

const StackedSection = ({
  title,
  text,
  btnText,
  img,
  link,
  icon,
  light,
  alt,
}: StackedSectionProps): ReactElement => (
  <section
    className={classnames('home-section', 'stacked-container', light ? 'stacked-grey-bg' : '')}
  >
    {title && (
      <div className="home-heading">
        <i className={classnames('home-icon', `${icon}`)} />
        <h2 className="home-title">{title}</h2>
      </div>
    )}
    <div className="column-container">
      <a href={link} className="stacked-link">
        <img
          className="stacked-img"
          src={img}
          alt={title || alt}
          width={1630}
          height={762}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
        />
        <div
          className={classnames(
            'stacked-text-container',
            light ? 'home-title-light' : 'home-title-dark',
          )}
        >
          <p className="stacked-text">{text}</p>
          <button
            type="button"
            className={classnames(light ? 'btn-black' : 'btn-plain-inverted', 'stacked-btn')}
          >
            {btnText}
          </button>
        </div>
      </a>
    </div>
  </section>
);

export default StackedSection;
